import { Page } from '@/core/architecture'

import { EventDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * EventDetail Page
 * Implemented as a practical sample.
 */
export const EventDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <EventDetailTemplate state={state} {...actions} />
}
